var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "person-info" },
        [
          _c("div", [
            _c("label", { attrs: { for: "" } }, [_vm._v("姓名")]),
            _c("div", [_vm._v(_vm._s(_vm.recordList.Interviewee))]),
          ]),
          _c(
            "div",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("面談日期")]),
              _vm._l(_vm.recordList.InterviewDateList, function (date, index) {
                return _c("div", { key: index }, [
                  _vm._v(
                    " " + _vm._s(_vm.$common.dateTimeFormatter(date)) + " "
                  ),
                ])
              }),
            ],
            2
          ),
          _vm._l(_vm.recordList.Scores, function (score) {
            return _c("div", { key: score.Name }, [
              _c("label", { attrs: { for: "" } }, [_vm._v(_vm._s(score.Name))]),
              _c("div", [
                !_vm.IsSupervisor
                  ? _c("span", [_vm._v(_vm._s(score.OriginScore) + "/")])
                  : _vm._e(),
                _vm._v(_vm._s(score.Score) + " "),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm.recordList.InterviewRecords &&
      _vm.recordList.InterviewRecords.length > 0
        ? [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                {
                  staticClass: "interview-body",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _vm._m(0),
                  _vm._l(
                    _vm.recordList.InterviewRecords[0]
                      .InterviewRecordAppraisals,
                    function (item) {
                      return _c(
                        "div",
                        { key: item.Name, staticClass: "field" },
                        [_vm._v(" " + _vm._s(item.Name) + " ")]
                      )
                    }
                  ),
                  _vm.recordList.ResumeType === "IDL"
                    ? [_c("div", { staticClass: "field" }, [_vm._v("職等")])]
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      staticStyle: { height: "80px", "overflow-y": "auto" },
                    },
                    [_vm._v(" 面談說明 ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      staticStyle: { height: "80px", "overflow-y": "auto" },
                    },
                    [_vm._v(" 個人備註 ")]
                  ),
                  _vm.recordList.ResumeType === "IDL"
                    ? [
                        _c("div", { staticClass: "field" }, [
                          _vm._v("是否已進行風險評估"),
                        ]),
                      ]
                    : _vm._e(),
                  _c("div", { staticClass: "field" }, [_vm._v("面談結果")]),
                ],
                2
              ),
              _vm.recordList.InterviewRecords &&
              _vm.recordList.InterviewRecords.length > 0
                ? _c(
                    "div",
                    { staticStyle: { flex: "1", "min-width": "1px" } },
                    [
                      _c(
                        "carousel",
                        {
                          staticStyle: { flex: "1", "min-width": "1px" },
                          attrs: { items: 1, nav: true, dots: true },
                        },
                        _vm._l(
                          _vm.recordList.InterviewRecords,
                          function (record) {
                            return _c(
                              "div",
                              {
                                key: record.InterviewId,
                                staticClass: "evaluation-body",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "interview-body" },
                                  [
                                    _c("div", { staticClass: "tab-name" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "name-inner",
                                          staticStyle: { height: "55px" },
                                        },
                                        [
                                          _vm._v(
                                            " 【" +
                                              _vm._s(record.InterviewTitle) +
                                              "】"
                                          ),
                                          _c("br"),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  record.InterviewSupervisor +
                                                  " (" +
                                                  record.InterviewUserType +
                                                  ")",
                                                placement: "right",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      record.InterviewSupervisor
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      record.InterviewUserType
                                                    ) +
                                                    ") "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._l(
                                      record.InterviewRecordAppraisals,
                                      function (item) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.Name,
                                            staticClass: "field",
                                          },
                                          [
                                            item.Remark &&
                                            item.Result !== "-" &&
                                            item.Remark !== "未填寫"
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      effect: "dark",
                                                      content: item.Remark,
                                                      placement: "right",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.Result) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(_vm._s(item.Result)),
                                                ]),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm.recordList.ResumeType === "IDL"
                                      ? [
                                          _c("div", { staticClass: "field" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  record.ExpectedJobLevel
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field",
                                        staticStyle: {
                                          height: "80px",
                                          "overflow-y": "auto",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(record.Remark) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field",
                                        staticStyle: {
                                          height: "80px",
                                          "overflow-y": "auto",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(record.PersonalRemark) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm.recordList.ResumeType === "IDL"
                                      ? _c("div", { staticClass: "field" }, [
                                          record.InterviewResult === "未填寫"
                                            ? _c("div", [_vm._v("未填寫")])
                                            : _c("div", [_vm._v("已完成評估")]),
                                        ])
                                      : _vm._e(),
                                    _c("div", { staticClass: "field" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(record.InterviewResult) +
                                          " "
                                      ),
                                    ]),
                                  ],
                                  2
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tab-name" }, [
      _c(
        "div",
        {
          staticClass: "name-inner",
          staticStyle: { height: "55px", "line-height": "50px" },
        },
        [_vm._v(" 面談主管 ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }